import { useCallback, useEffect } from 'react';
import { isInteractiveElement } from '@bynder-studio/misc';
import { isCtrlKey } from '~/helpers/hotKeys';

const useVisibilityControlsShortcuts = ({ toggleVisibility }: { toggleVisibility?: () => void }) => {
    const handleKeyDown = useCallback(
        (e: KeyboardEvent): void => {
            if (isInteractiveElement(e) || isCtrlKey(e) || e.shiftKey) {
                return;
            }

            switch (e.code) {
                case 'KeyS': {
                    toggleVisibility && toggleVisibility();

                    break;
                }

                default:
                    break;
            }
        },
        [toggleVisibility],
    );

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyDown]);
};

export default useVisibilityControlsShortcuts;
